module.exports = __webpack_public_path__ + "static/media/z.877ea6b2.png";